module.exports = __webpack_public_path__ + "img/176.14118f96.jpg";